export function haveStepsChanged(newSteps, oldSteps) {
  if (!oldSteps) return true;
  if (!newSteps) return true;
  if (newSteps.length !== oldSteps.length) return true;

  // If multi-trips, flatten and compare
  const flatten = arr => Array.isArray(arr[0]) ? arr.flat() : arr;

  const newFlat = flatten(newSteps);
  const oldFlat = flatten(oldSteps);

  if (newFlat.length !== oldFlat.length) return true;

  for (let i = 0; i < newFlat.length; i++) {
    const newCoord = newFlat[i]?.point?.coordinates;
    const oldCoord = oldFlat[i]?.point?.coordinates;

    if (!newCoord || !oldCoord) return true;

    if (newCoord.length !== oldCoord.length) return true;

    for (let j = 0; j < newCoord.length; j++) {
      if (newCoord[j] !== oldCoord[j]) return true;
    }
  }

  return false; 
}